module.exports = __webpack_public_path__ + "img/isologobl2.c761e310.png";